function MainWeb() {
}

MainWeb.fn = {
    init: function () {
        MainWeb.fn.productDetailImage.call(this);
        MainWeb.fn.productDetailTab.call(this);
    },

    productDetailImage: function () {
        $(document).on("click", ".thumbnail", function () {
            // remove active class
            $(".thumbnail").removeClass("thumbnail--active");

            // add active to this
            $(this).addClass("thumbnail--active");

            // get image url from thumbnail
            const newImage = $(this).find("img").attr("srcset");

            // update main image
            $(".product-detail__product-image").attr("srcset", newImage).attr("src", newImage);
        });
    },

    productDetailTab: function () {
        $(document).on("click", ".product-tab-control", function (e) {
            e.preventDefault();

            var $wrapper = $(this).closest(".product-tab-wrapper");

            // remove active class from all tabs
            $wrapper.find(".product-tab-control").removeClass("product-tab-control--active");
            // add active class to clicked tab
            $(this).addClass("product-tab-control--active");

            // get target from href (#productDescription, #ingredients, ...)
            var target = $(this).attr("href");

            // hide all content
            $wrapper.find(".product-tab-content").addClass("d-none");

            // show selected content
            $wrapper.find(target).removeClass("d-none");

            // optional: scroll to the tab content smoothly
            var $scrollTarget = $wrapper.closest(".popup__content").length
            ? $wrapper.closest(".popup__content")    
            : $("html, body");      
            
            $scrollTarget.animate({
                scrollTop: $(target).offset().top - 20
            }, 300);
        });
    },

    rule: function () {
        $(document).ready(function () {
            MainWeb.fn.init.call(this);
        });
    },
};

MainWeb.fn.rule();
